import styled from 'react-emotion';

import {inputStyles} from 'app/styles/input';

const Input = styled.input`
  ${inputStyles};
`;

export default Input;
